export default __webpack_public_path__ + "static/media/sort-1.e249022a.svg";